import { render, staticRenderFns } from "./FlexContainer.vue?vue&type=template&id=6ef91565"
import script from "./FlexContainer.ts?vue&type=script&lang=ts&external"
export * from "./FlexContainer.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports